import { useRef } from "react"
import { ClassProps } from "../../utility/common/props"
import { Project } from "../../models/project"
import cn from "classnames"
import styles from "./ProjectCard.module.scss"
import TooltipTrigger from "../TooltipTrigger/TooltipTrigger"
import { testId } from "../../utility/tests/testId/menu"

const PROJECT_NAME_MAX_LENGTH = 13

interface ProjectCard extends ClassProps {
    project: Project
    onClick?: () => void
    isShort?: boolean
}

const ProjectCard = (props: ProjectCard) => {
    const { project, onClick, className, isShort } = props
    const cardRef = useRef<HTMLDivElement>(null)

    return (
        <TooltipTrigger
            id={project.id}
            content={project.name}
            placement="right"
            condition={isShort || project.name.length >= PROJECT_NAME_MAX_LENGTH}
            container={cardRef}
            className={styles.projectCard__tooltip}
        >
            <div
                className={cn(styles.projectCard, className, isShort && styles.projectCard_short)}
                onClick={() => onClick && onClick()}
                data-project-id={project.id}
                data-testid={testId.projectCard}
                style={onClick && { cursor: "pointer" }}
                ref={cardRef}
            >
                <div className={styles.projectCard__image}>
                    {project.logo && (
                        <img
                            src={project.logo}
                            alt=""
                            className={styles.projectCard__imageItem}
                            width="30px"
                            height="30px"
                        />
                    )}
                </div>
                <div className={styles.projectCard__name}>
                    <span className={styles.projectCard__nameItem}>{project.name}</span>
                </div>
            </div>
        </TooltipTrigger>
    )
}

export default ProjectCard
